import { FC, PropsWithChildren } from "react";
import Skeleton from "react-loading-skeleton";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import classNames from "classnames";

import { BaseProps } from "../../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The `InputContainerPlaceholder` component properties.
 */

export interface InputContainerPlaceholderProps extends BaseProps {
  /**
   * Indicates whether the component has instructions. If not specified defaults to `false`.
   */
  readonly hasInstructions?: boolean;
}

/**
 * Component which acts as the container for all inputs.
 */
export const InputContainerPlaceholder: FC<PropsWithChildren<InputContainerPlaceholderProps>> = (props) => {
  const { children, hasInstructions = false } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: ["placeholder"],
  });

  return (
    <Stack {...getBasePropsFromHtmlProps(baseHtmlProps)} spacing="mini">
      <div className={classNames(styles.PlaceholderLabel, "label")}>
        <Skeleton />
      </div>
      {children}
      {hasInstructions && (
        <div className={classNames(styles.PlaceholderInstructions, "instructions")}>
          <Skeleton />
        </div>
      )}
    </Stack>
  );
};
